import {
  IconBrandAzure,
  IconBrandGithub,
  IconBrandLeetcode,
  IconBrandLinkedin,
  IconBrandTwitter,
} from "@tabler/icons-react";

const Info = {
  name: "Saran Kumar",
  stack: [
    "AI Engineer",
    "Cloud Engineer",
    "AI Architect",
    "IT Engineer",
    "Full Stack Developer",
  ],
  bio: [
    " Microsoft Azure and Oracle Certified Cloud & AI Engineer with 14 years of experience in cloud infrastructure, backend development, and intelligent automation. Proven expertise in deploying and managing Azure Virtual Machines, designing scalable microservices, and integrating Generative AI solutions using Python, JSON, and REST APIs into enterprise workflows. Architected Agentic AI chatbot solutions for Microsoft Outlook, SharePoint, and Teams, leveraging LangChain, Retrieval-Augmented Generation  and GPT-based large language models  to enhance productivity and automation across business operations. Experienced in full-stack development, cloud computing, and AI integration. Committed to continuous learning and leveraging cutting-edge technologies to drive impactful results.",
  ],
  Certifications: [
            
                "Microsoft Certified: Azure Administrator Associate AZ-104, Year-2025, Renewed 2026",
                "Microsoft Certified: Azure AI Engineer Associate AI-102, Year-2025, Renewed 2026",
                "Oracle Cloud Infrastructure 2025 Certified Generative AI Professional, year-2025",
                "Oracle Cloud Infrastructure 2025 Certified AI Foundations Associate, year-2025",
 
  ],
};

const ProjectInfo = [
  {
    title: "Generative AI- Powered Automated Document Summarization and Chatbot for Enterprise Knowledge Management",
    desc: "Developed Agentic AI chatbot using LangGraph, OpenAI GPT models, and RAG (Retrieval-Augmented Generation) to summarize enterprise documents from SharePoint, Outlook, and Teams. Implemented vector search with FAISS/ChromaDB for intelligent context retrieval. Impact: Enhanced employee productivity by 40% through automated information retrieval and context-aware responses.",
    image: "Project1.jpeg",
    live: true,
    technologies: [
      "Python",
      "React",
      "LangGraph",
      "RAG",
      "OpenAI API",
      "Vector DB",
      "Azure OpenAI",
    ],
    
    link: "www.linkedin.com/in/saran-kumar-146001239",
    github: "https://github.com/Rockskp/",
  },
  {
    title: "Smart Banking Assistant with AI-Driven Document Analysis",
    desc: " Developed an AI-powered banking assistant using React for the front end and Spring Boot for the back end. Integrated OpenAI's GPT models to analyze and summarize complex financial documents,financial guidance and banking services, Features: Customer profiling, financial analysis, investment recommendations. Technologies: Machine learning, NLP, cloud infrastructure. Benefits: Improved customer experience, increased efficiency, risk management Potential uses: Transaction alerts, budgeting, portfolio management. Data sources: Banking systems, market data feeds. Security: Robust measures to protect sensitive customer data. Deployment: Cloud platform for scalability and reliability. Goal: Enhance customer satisfaction and banking operations efficiency.Implemented secure user authentication and data encryption to ensure compliance with financial regulations. Impact: Reduced document analysis time by 60% and enhanced customer satisfaction through personalized financial advice.",
    image: "Project2.jpeg",
    live: false,
    technologies: [
      "React",
      "Springboot",
      "MongoDB",
      "Tailwind",
      "Tabler-Icons",
      "Firebase",
    ],
    link: "www.linkedin.com/in/saran-kumar-146001239",
    github: "https://github.com/Rockskp/",
  },

  {
    title:"Real-time Financial Transaction Analysis and Risk Assessment System",
    desc: "Collect transactions via Kafka. Process data using Java-based Kafka Streams. Apply rules to detect suspicious activity. Use Python for machine learning-based fraud prediction. Store data in NoSQL database (Cassandra/MongoDB). Visualize insights using Tableau/Power BI. Send alerts via Java-based notification system. Integrate with SMS/email/mobile app notifications. Features: Real-time transaction monitoring. Predictive analytics for fraud detection. Customizable alert system. Data visualization dashboard. Real-time customer sentiment analysis and personalized product recommendations. Technologies: Java for Kafka Streams and alerts. Python for machine learning. Kafka for data ingestion and streaming. NoSQL database for data storage. Data visualization tool for insights. Azure Active Directory, RBAC, MFA, and Conditional Access for security. Benefits: Improved fraud detection. Enhanced customer experience. Increased efficiency and reduced risk. Personalized product recommendations. Potential uses: Fraud detection, risk assessment, customer insights. Data sources: Transaction data, customer profiles, market data. Security: Robust measures to protect sensitive financial data. Deployment: Cloud platform for scalability and reliability. Goal: Enhance financial security and customer satisfaction. Impact: Reduced fraud incidents by 45% and improved customer retention through personalized services.",
    image: "Project3.jpeg",
    live: false,
    technologies: [
    "Apache Kafka",
    "Java",
    "Python",
    "Kafka Streams",
    "NoSQL Database (Cassandra/MongoDB)",
    "Data Visualization (Tableau/Power BI)",
    "ETL (Extract, Transform, Load)",
    "Data Pipelines", "ETL-Extract, Transform, Load", "Data Pipelines"],
    link: "www.linkedin.com/in/saran-kumar-146001239",
    github: "https://github.com/Rockskp/",


  },
  {
      title: "Maven Springboot Project",
      desc: "Spotify Clone is a full-stack web application that replicates the core features of Spotify, including user authentication, music playback, and playlist creation. The front end is built with React, TailwindCSS, Heroicons, and Firebase, while the back end uses Firebase for user authentication and data storage. Users can create an account, log in, search for songs, and create playlists. The app features real-time updates, so users can see new songs as they are added. Spotify Clone provides a seamless user experience with a clean, modern design and intuitive functionality. It serves as a great project build a full-stack web application using modern technologies.",
      image: "Project3a.png",
      live: false,
      technologies: [
        "React",
        "Springboot",
        "Java",
        "Tabler-Icons",
        "Maven",
        "MongoDB",
        "Firebase",
      ],
      link: "www.linkedin.com/in/saran-kumar-146001239",
      github: "https://github.com/Rockskp/mavenSpringBoot",
    },
  {
    title: "Azure Cloud Infrastructure Implementation",
    desc: " Designed and implemented scalable cloud infrastructure on Microsoft Azure, including Virtual Networks, VMs, and Storage Accounts. Automated deployments using ARM templates and managed identity and role-based access control (RBAC) for secure resource access. Monitored system performance with Azure Monitor and Log Analytics, creating custom dashboards for real-time insights. Impact: Achieved 99.9% uptime and reduced manual deployment time by 70% through automation.",
    image: "Project4.png",
    live: false,
    technologies: [
      "Microsoft Azure",
      "ARM Templates",
      "Azure VMs", "Azure AD",
      "RBAC",
      "Azure Monitor",
      "Azure Data Lake",
      "SQL Server", "PostgresSQL","Azure HDInsight", "Azure Hostpool", "Azure Virtual Desktop"
    ],
  link: "www.linkedin.com/in/saran-kumar-146001239",
    github: "https://github.com/Rockskp/",
  },
  {
    title: "Hybrid Cloud Governance, Intune, MDM, Secure Identity, Access Management (IAM) & Cost Optimization",
    desc: "Designed multi-cloud architecture with Azure and AWS ensuring governance, compliance, and cost optimization. Deployed automated cost-control policies and centralized monitoring for workloads across environments. Maintained VM synchronization jobs and services like Harvester and Coddler for system consistency. Implemented RBAC, MFA, and Conditional Access using Azure Active Directory to strengthen user and application security. Integrated Azure Monitor and Log Analytics for proactive system monitoring and alerting via custom dashboards. Managed secure identity and access using Azure AD, Conditional Access, and Privileged Identity Management (PIM). Conducted cost analysis and optimization using Azure Cost Management and implemented tagging strategies for resource tracking. Impact: Reduced cloud expenditure by 25% while enhancing security and compliance across hybrid environments. It improved operational efficiency and ensured robust access controls.",
    image: "Project6.png",
    live: false,
    technologies: [
      "Microsoft Azure",
      "AWS","S3",
      "Hybrid Cloud","VPS",
      "Cloud Governance",
      "Cost Optimization",
      "IAM",
      "Azure AD",
      "RBAC",
      "MFA",
      "PIM",
      "Azure Monitor",
      "Log Analytics",
      "Cost Management",
      "Tagging Strategies",

      ],
    link: "www.linkedin.com/in/saran-kumar-146001239",
    github: "https://github.com/Rockskp/",
  },
];

const SkillInfo = [
  {
    title: "Frontend Development",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
      "React JS",
      "Angular",
      "Redux",
      "Tailwind CSS",
      "Bootstrap",
    ],
  },
  {
    title: "Backend Development",
    skills: [
      "Springboot",
      "Node JS",
      "MySQL",
      "MongoDB",
      "Firebase",
      "PostgresSQL",
    ],
  },
  {
    title: "AI & Data Science",
    skills: ["Python", "Pandas", "NumPy", "Matplotlib", "Scikit-Learn", "TensorFlow","Kafka"],
  },
  {
    title: "Cloud Platforms",
    skills: [
      "Microsoft Azure",
      "Oracle Cloud",
      "Azure VMs",
      "Azure AD",
      " RBAC",
      "Azure Monitor",
      "Azure Data Lake",
      "AWS",
      "S3",
    ],
  },
  {
    title: "Languages and Tools",
    skills: [
        "Java", "Python", "JavaScript", "TypeScript",
      "Git",
      "Github",
      "VS Code",
      "Postman",
      "MongoDB Compass",
      "AzureBotFramework",
      "Spring Tool Suite",
      "IntelliJ IDEA",
      "Eclipse IDE",
      "Android Studio",
      " Docker",
      " Kubernetes",
      " Jenkins",
      "CI CD Pipelines",
    ],
  },
  {
    title: "Generative AI & LLMs Integration",
    skills: [
      "OpenAI GPT Models",
      "Azure OpenAI",
      "LangChain",
      "Google Studio API",
      "RAG",
      "Vector Databases",
      "RESTful APIs",
        "JSON",
        "NLP",
        "Chatbot Development",
        "AI Model Fine-Tuning",
        "Prompt Engineering",
        "AI Ethics and Compliance",
        "N8N Platform Automation",

    ],
  },
];
const socialLinks = [
  { link: "https://github.com/Rockskp", icon: IconBrandGithub },
  { link: "https://www.linkedin.com/in/saran-kumar-146001239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app", icon: IconBrandLinkedin },
  { link: "https://x.com/explore", icon: IconBrandTwitter },
  { link: "https://azure.microsoft.com/en-us/products/ai-services", icon: IconBrandAzure,
  },
  { link: "https://leetcode.com/progress/", icon: IconBrandLeetcode },
];

const ExperienceInfo = [

  {
    role: "Sr Azure Cloud Engineer and AI Engineer",
    company: "Elevance Health, Indiana (Remote), USA",
    date: "May- 2025 to Present",
    desc: " Azure AI Engineer with strong experience in cloud infrastructure, Azure VM, Azure Storage, Azure CosmoDB, Data Factory, Data link, Data-Bricks, Kubernetes, Docker, DevOps, and building Generative AI & Agentic AI solutions using Azure OpenAI, LangChain, LangGraph and multi-cloud architectures.",
    skills: [
      
      "Microsoft Azure",
      "AWS",
      "Azure Data Lake",
      "Azure HDInsight",
      "Azure Hostpool",
      "Azure Virtual Desktop",
      "Azure Data Factory",
      "Azure Databricks",
      "Python",
      "Terraform",
      "ARM Templates",
      "Azure VMs",
      "Azure AD",
      "RBAC",
      "MFA",
      "Conditional Access",
      "Azure Monitor",
      "LangChain",
      "Azure OpenAI",
      "LangGraph",
      "Google Studio API",
      "NLP",
      "AI Ethics and Compliance",
      "Agentic AI",
      "Azure Foundry",
      "Chatbot Development",
      "AI Model Fine-Tuning",
      "Prompt Engineering",
      "AI Ethics and Compliance",
      "N8N Platform Automation",
      "OpenAI GPT Models",
      "RAG",
      "Vector Databases",
      "Json",
      "Power BI",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "Scikit-Learn",
      "Apache Kafka",
      "RESTful APIs",
      "React JS",
      "Node JS",
      "TensorFlow",
      
    ],
  },
  {
    role: "Lead Azure Cloud  and AI Architect",
    company: "CapitalOne, Hoboken, NJ, USA",
    date: "May- 2023 to Apr-2025",
    desc: " Provisioned and optimized Azure VMs across departments using Azure AD, enhancing performance and availability. Automated secure deployments with ARM templates and Terraform; configured NSGs, VNets, and storage. Implemented RBAC, MFA, Conditional Access; monitored systems via Azure Monitor and custom dashboards. Designed CI/CD cloud architectures across Azure/AWS with governance, cost control, and VM sync services. Built Generative AI apps using LangChain, OpenAI, RAG, and vector DBs for summarization and chat agents. Developed ML models and ETL pipelines with Python, TensorFlow, Kafka, and Databricks for real-time insights.",
    skills: [
      
      "Microsoft Azure",
      "Python",
      "Terraform",
      "ARM Templates",
      "Azure VMs",
      "Azure AD",
      "RBAC",
      "MFA",
      "Conditional Access",
      "Azure Monitor",
      "Azure Data Lake",
      "Azure HDInsight",
      "LangChain",
      "Azure OpenAI",
      "LangGraph",
      "Google Studio API",
      "NLP",
      "Chatbot Development",
      "AI Model Fine-Tuning",
      "Prompt Engineering",
      "AI Ethics and Compliance",
      "N8N Platform Automation",
      "OpenAI GPT Models",
      "RAG",
      "Vector Databases",
      "Apache Kafka",
      "RESTful APIs",
      "React JS",
      "Node JS",
      "TensorFlow",
      
    ],
  },
 {
    role: "Azure Cloud Engineer and AI Engineer",
    company: "Northern Trust, NYC, USA",
    date: "May-2021 to Apr- 2023",
    desc: "Provisioned and optimized Azure VMs across departments using Azure AD, enhancing performance and availability. Automated secure deployments with ARM templates and Terraform; configured NSGs, VNets, and storage. Implemented RBAC, MFA, Conditional Access; monitored systems via Azure Monitor and custom dashboards. Designed CI/CD cloud architectures across Azure/AWS with governance, cost control, and VM sync services. Built Generative AI apps using LangChain, OpenAI, RAG, and vector DBs for summarization and chat agents. Developed ML models and ETL pipelines with Python, TensorFlow, Kafka, and Databricks for real-time insights.",
    skills: [
      "Microsoft Azure",
      "Python",
      "ARM Templates",
      "Azure VMs",
      "Azure AD",
      "RBAC",
      "MFA",
      "Conditional Access",
      "Azure Monitor",
      "Powershell",
      "Json",
      
    ],
  },

  {
    role: "Software Engineer",
    company: "Molina HealthCare, Remote USA",
    date: "Jun-2018 to Apr-2021",
    desc: " Built responsive web apps using HTML5, CSS3, JavaScript, React.js, and Angular.js with dynamic routing and JWT. Developed scalable RESTful APIs and microservices using Java 1.8, Spring Boot, Hibernate, and J2EE design patterns. Integrated REST APIs, XML/JAXB, and Apache Camel for protocol-based messaging with JMS and async processing. Automated CI/CD with Jenkins, Maven, Git; deployed on AWS EC2, Elastic Beanstalk, and managed Ubuntu instances. Designed relational schemas, wrote complex SQL queries, and used Hibernate for ORM with Oracle and MySQL. I optimized database performance and reliability, and collaborated with cross-functional teams to enhance system operations and ensure seamless integration.",
    skills: [
      "Java",
      "MySQL",
      "Hibernate",
      "Selenium",
      "Jenkins",
      "JIRA",
      "Automation Testing",
      "Springboot",
      "React JS",
      "Angular",
      "Node JS",
        "Powershell",
      "MongoDB",
      "Microservices",
    ],
  },
  
 {
    role: "Software Engineer",
    company: " Petro net LNG Limited, India.   ",
    date: "Dec-2012 to Apr- 2015",
    desc: "Designed and developed dynamic user interfaces using JSF, HTML, CSS, Java, SpringMVC, Restfull API and XML with components like tab panels, panel groups, and data tables.Implemented backend services with Java, J2EE, Spring, and Hibernate, creating RESTful APIs for seamless frontend-backend communication. Managed database interactions using SQL and Hibernate ORM with Oracle and MySQL databases. Developed web services using SOAP and REST protocols for external system integration. Automated deployment processes using Jenkins and Maven, ensuring efficient CI/CD pipelines. Collaborated with cross-functional teams to gather requirements, design solutions, and enhance system functionality.",
    skills: [
     
      "Java",
      "J2EE",
      "Spring",
      "Hibernate",
      "SQL",
      "Spring MVC",
      "RESTful APIs",
      "Springboot",
      "React JS",
      "Angular",
      "Powershell",
      "Json",
      "SOAP",
      "Linux",
      "ubuntu",
      
    ],
  },

  {
    role: "IT Engineer",
    company: "PRAJ Industries Ltd, India",
    date: "Jan-2008 to Nov-2012",
    desc: "Developed the front-end and controller sections of a CMS project using HTML5, CSS3, JavaScript, jQuery, Spring Boot, Hibernate, and J2EE design patterns. Integrated REST APIs, XML/JAXB, and Apache Camel for protocol-based messaging with JMS and async processing. Automated CI/CD with Jenkins, Maven, Git; deployed on AWS EC2, Elastic Beanstalk, and managed Ubuntu instances. Designed relational schemas, wrote complex SQL queries, and used Hibernate for ORM with Oracle and MySQL. I optimized database performance and reliability, and collaborated with cross-functional teams to enhance system operations and ensure seamless integration.",
    skills: [
      "Java",
      "J2EE",
      "Spring",
      "Hibernate",
      "SQL",
      "Spring MVC",
      "RESTful APIs",
      "Powershell",
      "Json",
      "SOAP",
      "Linux",
      "ubuntu",
   
      "Angular",
   
    
    ],
  },
];
const Slugs = [
  "typescript",
  "spring",
  "javascript",
  "dart",
  "java",
  "react",
  "angular",
  "html5",
  "css3",
  "springboot",
  "mongodb",
  "selenium",
  "python",
  "nodejs",
  "azure",
  "mysql",
  "amazonaws",
  "postgresql",
  "firebase",
  "nginx",
  "tailwindcss",
  "bootstrap",
  "docker",
  "testinglibrary",
  "jenkins",
  "git",
  "jira",
  "github",
  "gitlab",
  "visualstudiocode",
  "androidstudio",
  "eclipseide",
  "intellijidea",
  "postman",
];
export { Info, ProjectInfo, socialLinks, SkillInfo, ExperienceInfo, Slugs };
